import { render, staticRenderFns } from "./asistenciacomputadorasarneses.vue?vue&type=template&id=7896e955&"
import script from "./asistenciacomputadorasarneses.vue?vue&type=script&lang=ts&"
export * from "./asistenciacomputadorasarneses.vue?vue&type=script&lang=ts&"
import style0 from "./asistenciacomputadorasarneses.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports